/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manageyourbusinesseventsandactivities5Inputs */

const en_manageyourbusinesseventsandactivities5 = /** @type {(inputs: Manageyourbusinesseventsandactivities5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your business events and activities`)
};

const de_manageyourbusinesseventsandactivities5 = /** @type {(inputs: Manageyourbusinesseventsandactivities5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalte die Events und Aktivitäten deines Unternehmens`)
};

/**
* | output |
* | --- |
* | "Manage your business events and activities" |
*
* @param {Manageyourbusinesseventsandactivities5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const manageyourbusinesseventsandactivities5 = /** @type {((inputs?: Manageyourbusinesseventsandactivities5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manageyourbusinesseventsandactivities5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_manageyourbusinesseventsandactivities5(inputs)
	return de_manageyourbusinesseventsandactivities5(inputs)
});
export { manageyourbusinesseventsandactivities5 as "manageYourBusinessEventsAndActivities" }